import { choose } from '../../utils/platform';
import CountGroupFormDesktop from './CountGroupForm.desktop';
import CountGroupFormMobile from './CountGroupForm.mobile';

export default choose(CountGroupFormDesktop, CountGroupFormMobile);
